import React from 'react';
import { IoIosSearch } from 'react-icons/io';

import { TextInput } from './text-input';

interface SearchProps {
  text: string;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

export const Search: React.FC<SearchProps> = ({
  text,
  placeholder = 'Search...',
  onChange,
  className = '',
}) => {
  return (
    <TextInput
      value={text}
      placeholder={placeholder}
      onChange={onChange}
      className={className}
      icon={IoIosSearch}
    />
  );
};
